import Vue from 'vue';
import VueI18n from 'vue-i18n';
import getBrowserLocale from '@/utils/i18n/getBrowserLocale';
import { supportedLocalesInclude } from '@/utils/i18n/supportedLocales';
import dateTimeFormats from '@/locales/date-time-formats';
import numberFormats from '@/locales/number-formats';

Vue.use(VueI18n);

function getStartingLocale() {
  const browserLocale = getBrowserLocale({ countryCodeOnly: true });

  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale;
  }
  return process.env.VUE_APP_I18N_LOCALE || 'en';
}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

export default new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages(),
  dateTimeFormats,
  numberFormats,
});

//* If locale files start getting too large, look into async loading of them with this 👇
// const startingLocale = getStartingLocale();

// const i18n = new VueI18n({
//   locale: getStartingLocale(),
//   fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
//   messages: {},
//   dateTimeFormats,
//   numberFormats,
// });

// const loadedLanguages = [];

// export function loadLocaleMessagesAsync(locale) {
//   console.log('locale:', locale);
//   if (loadedLanguages.length > 0 && i18n.locale === locale) {
//     console.log('here1');
//     return Promise.resolve(locale);
//   }

//   //* if the language was already loaded
//   if (loadedLanguages.includes(locale)) {
//     console.log('here2');
//     i18n.locale = locale;
//     return Promise.resolve(locale);
//   }

//   //* if the language hasn't been loaded yet
//   return import(/* webpackChunkName: "locale-[request]" */ `@/locales/${locale}.json`).then(
//     (messages) => {
//       console.log('here3');
//       console.log('messages:', messages);
//       i18n.setLocaleMessage(locale, messages.default);

//       loadedLanguages.push(locale);

//       i18n.locale = locale;

//       return Promise.resolve(locale);
//     }
//   );
// }

// loadLocaleMessagesAsync(startingLocale);

// export default i18n;
